import { render, staticRenderFns } from "./OriginalEditForm.vue?vue&type=template&id=f385e78e&scoped=true"
import script from "./OriginalEditForm.vue?vue&type=script&lang=js"
export * from "./OriginalEditForm.vue?vue&type=script&lang=js"
import style0 from "./OriginalEditForm.vue?vue&type=style&index=0&id=f385e78e&prod&lang=scss&scoped=true"
import style1 from "./OriginalEditForm.vue?vue&type=style&index=1&id=f385e78e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f385e78e",
  null
  
)

export default component.exports